import { render, staticRenderFns } from "./permissionShow.vue?vue&type=template&id=1da82d94&scoped=true&"
import script from "./permissionShow.vue?vue&type=script&lang=js&"
export * from "./permissionShow.vue?vue&type=script&lang=js&"
import style0 from "./permissionShow.vue?vue&type=style&index=0&id=1da82d94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da82d94",
  null
  
)

export default component.exports